import React from "react";
import { Box, Typography } from "@mui/material";

export default function HomeDefault(params) {
  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        variant="h3"
        gutterBottom
        sx={{ textTransform: "uppercase", fontSize: "48px" }}
      >
        Home Page Not Implemented
      </Typography>
    </Box>
  );
}
